import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b005635"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-align-items-center is-flex is-flex-direction-row" }
const _hoisted_2 = {
  key: 0,
  class: "has-text-centered has-text-weight-bold"
}

import TwoDModal from '@/components/library/content/TwoDModal.vue'
import { computed, onBeforeMount, Ref, ref } from 'vue'
import { Thumbnail } from '@/components/common'
import { useComposableForEsc } from '@/components/common/modal/useComposableForEsc'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPreview',
  props: {
  content: {
    type: Object,
    required: true
  },
},
  setup(__props) {

const props = __props

const entityType = props.content.contentType ||
  props.content.entityType ||
  props.content.mediaType ||
  props.content.type
const filepathFor2d: Ref<string> = ref('')
const is2dPreviewOpen = ref(false)
const previewModalTitle = ref('')

const canShowPreview = computed(() => {
  const supportedTypes = new Set(["part", "product-page"])
  if (!supportedTypes.has(entityType)) return false
  return !!filepathFor2d.value
})
const onClosePreviewModal = () => {
  is2dPreviewOpen.value = false
}
const onOpenPreviewModal = () => {
  if (!canShowPreview.value) return
  if (!filepathFor2d.value) return
  is2dPreviewOpen.value = true
}

onBeforeMount(async () => {
  if (!!props.content.thumbnailUrlLarge) {
    filepathFor2d.value = `${window.location.protocol}//${window.location.host}${props.content.thumbnailUrlLarge}`
  }

  if (!!props.content?.partNumber) {
    previewModalTitle.value = `${props.content.name} (${props.content.partNumber})`
  } else {
    previewModalTitle.value = `${props.content.name}`
  }
})

useComposableForEsc({
  dismissFunction: onClosePreviewModal,
  isActive: computed(() => is2dPreviewOpen.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'cursor-pointer': canShowPreview.value }),
        onClick: onOpenPreviewModal
      }, [
        _createVNode(_unref(Thumbnail), {
          class: "info-thumbnail",
          "data-int": "info-thumbnail",
          "thumbnail-type": _unref(entityType),
          "thumbnail-url": __props.content.thumbnailUrlLarge
        }, null, 8, ["thumbnail-type", "thumbnail-url"]),
        (canShowPreview.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('clickToEnlarge')), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _withDirectives(_createVNode(TwoDModal, {
      filepath: filepathFor2d.value,
      title: previewModalTitle.value,
      onClose: onClosePreviewModal
    }, null, 8, ["filepath", "title"]), [
      [_vShow, is2dPreviewOpen.value]
    ])
  ], 64))
}
}

})